import React from 'react'
import { Alert, AlertTitle } from '@mui/material'

const ModalAlert = ({ severity, title, message, sx }) => {
  return (
    <Alert severity={severity} sx={sx}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  )
}

export default ModalAlert
